<template>
    <div class="user-search-filters">
        <!-- ----------------------------- -->
        <!-- Desine sperare qui hic intras -->
        <!-- ----------------------------- -->

        <h3 class="title">ФИЛЬТРЫ</h3>

        <ModelSwitch v-if="isFavorite" label="Показывать избранных" v-model="filters.favorite_membership.status" />

        <ModelSwitch
            v-if="isFavorite"
            label="Установлено мобильное приложение РСВ"
            v-model="filters.profile.withRsvMobileApp"
        />

        <YesNoAnyInput
            v-if="withDrafts"
            title="Профиль пользователя является черновиком"
            :yes-value="true"
            :no-value="false"
            v-model="filters.profile.withDrafts"
        />

        <YesNoAnyInput
            v-if="isImportantFieldsFilled"
            title="Входят в ФП «Соцлифты для каждого»"
            :yes-value="true"
            :no-value="false"
            v-model="filters.profile.importantFieldsFilled"
        />

        <ModelMultiAutoComplete
            v-if="showInput"
            class="user-search-filters__main-cities"
            label="Адрес проживания"
            :selected="filters.profile.addresses"
            v-model="filters.profile.addresses"
            :search="autoCompleteAddresses"
            @debounce-end="getAutocompleteAddress"
            noInputText="Введите адрес проживания"
            noResultText="Адрес не найден"
            useObject
            itemValue="value"
            itemText="value"
        />
        <ModelMultiAutoComplete
            v-if="showInput"
            class="user-search-filters__main-citizenship"
            label="Гражданство"
            :selected="filters.profile.citizenship"
            v-model="filters.profile.citizenship"
            :search="autoCompleteCountry"
            @debounce-end="getCitizenship"
            noInputText="Введите название страны"
            noResultText="Страна не найдена"
        />

        <YesNoAnyInput
            title="Пол"
            yes-label="Мужской"
            yes-value="1"
            no-label="Женский"
            no-value="0"
            v-model="filters.profile.gender"
        />

        <div>
            <h4 class="label">Возраст</h4>
            <div class="user-search-filters__from-to-wrapper">
                <ModelString label="От" v-model="filters.profile.ageGt" v-if="showInput" type="number" />
                <ModelString v-if="showInput" label="До" v-model="filters.profile.ageLt" type="number" />
            </div>
        </div>

        <div>
            <h4 class="label">Дата регистрации на платформе</h4>
            <div class="user-search-filters__from-to-wrapper">
                <vc-date-picker
                    v-model="filters.profile.registrationDateFrom"
                    :model-config="{
                        type: 'string',
                        mask: 'YYYY-MM-DD',
                    }"
                >
                    <template v-slot="{ inputValue, togglePopover }">
                        <ModelString
                            label="С"
                            :value="inputValue || ''"
                            is-calendar
                            readonly
                            class="user-search-filters__from-to-date"
                            @click.native="togglePopover({ placement: 'auto-start' })"
                        />
                    </template>
                </vc-date-picker>
                <vc-date-picker
                    v-model="filters.profile.registrationDateTo"
                    :model-config="{
                        type: 'string',
                        mask: 'YYYY-MM-DD',
                    }"
                >
                    <template v-slot="{ inputValue, togglePopover }">
                        <ModelString
                            label="По"
                            :value="inputValue || ''"
                            is-calendar
                            readonly
                            class="user-search-filters__from-to-date"
                            @click.native="togglePopover({ placement: 'auto-start' })"
                        />
                    </template>
                </vc-date-picker>
            </div>
        </div>

        <h4 class="title">Участие в проектах, конкурсах РСВ</h4>

        <ModelMultiAutoComplete
            v-loading.small="loading.rootProjectsList"
            v-if="showInput"
            class="user-search-filters__projects-project"
            label="Корневой проект"
            itemValue="id"
            itemText="name"
            v-model="filters.nominations.rootProjects"
            :selected="getRootProjectsSelected"
            :search="rootProjectsList"
            @debounce-end="getRootProjects"
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.projectsTypesList"
            v-if="showInput"
            class="user-search-filters__projects-types"
            label="Тип проекта"
            itemValue="id"
            itemText="name"
            v-model="filters.nominations.projectsTypes"
            :selected="filters.nominations.projectsTypes"
            :search="getProjectsTypesFiltered"
            @debounce-end="getProjectsTypes"
            use-object
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.projectsList"
            v-if="showInput"
            class="user-search-filters__projects-project"
            label="Наименование проекта"
            itemValue="id"
            itemText="name"
            v-model="filters.nominations.projects"
            :selected="getProjectsSelected"
            :search="projectsListWithTypeFilter"
            @debounce-end="getProjects"
        />

        <ModelMultiAutoComplete
            v-loading.small="loading.projectsList"
            v-if="showInput"
            class="user-search-filters__projects-project user-search-filters__projects-project--exclude"
            label="Исключить проект"
            itemValue="id"
            itemText="name"
            v-model="filters.nominations.excludeProjects"
            :selected="getExcludeProjectsSelected"
            :search="projectsListWithTypeFilter"
            @debounce-end="getProjects"
        />

        <div class="user-search-filters__from-to-wrapper">
            <h5 class="user-search-filters__from-to-title">Дата регистрации в проект</h5>
            <vc-date-picker
                v-model="filters.nominations.projectRegisteredAtDateFrom"
                :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                }"
            >
                <template v-slot="{ inputValue, togglePopover }">
                    <ModelString
                        label="С"
                        :value="inputValue || ''"
                        is-calendar
                        readonly
                        class="user-search-filters__from-to-date"
                        @click.native="togglePopover({ placement: 'auto-start' })"
                    />
                </template>
            </vc-date-picker>
            <vc-date-picker
                v-model="filters.nominations.projectRegisteredAtDateTo"
                :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                }"
            >
                <template v-slot="{ inputValue, togglePopover }">
                    <ModelString
                        label="По"
                        :value="inputValue || ''"
                        is-calendar
                        readonly
                        class="user-search-filters__from-to-date"
                        @click.native="togglePopover({ placement: 'auto-start' })"
                    />
                </template>
            </vc-date-picker>
        </div>
        <ModelMultiAutoComplete
            v-loading.small="loading.nominationList"
            v-if="showInput"
            class="user-search-filters__projects-season"
            label="Номинация"
            itemValue="id"
            itemText="name"
            v-model="filters.nominations.seasons"
            :selected="getSeasonSelected"
            :disabled="disabled.nominationList"
            :search="nominationList"
            @debounce-end="getSeasons"
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.excludeSeasonsList"
            v-if="showInput"
            class="user-search-filters__projects-season user-search-filters__projects-season--exclude"
            label="Исключить номинацию"
            itemValue="id"
            itemText="name"
            v-model="filters.nominations.excludeSeasonsList"
            :selected="getExcludeSeasonsSelected"
            :disabled="disabled.excludeSeasonsList"
            :search="excludeSeasonsList"
            @debounce-end="getExcludeSeasons"
        />

        <div
            class="user-search-filters__from-to-wrapper"
            :disabled="disabled.nominationList || !getSeasonSelected.length"
        >
            <h5 class="user-search-filters__from-to-title">Дата регистрации в номинацию</h5>
            <vc-date-picker
                v-model="filters.nominations.nominationRegisteredAtDateFrom"
                :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                }"
            >
                <template v-slot="{ inputValue, togglePopover }">
                    <ModelString
                        label="С"
                        :value="inputValue || ''"
                        is-calendar
                        readonly
                        class="user-search-filters__from-to-date"
                        @click.native="togglePopover({ placement: 'auto-start' })"
                    />
                </template>
            </vc-date-picker>
            <vc-date-picker
                v-model="filters.nominations.nominationRegisteredAtDateTo"
                :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                }"
            >
                <template v-slot="{ inputValue, togglePopover }">
                    <ModelString
                        label="По"
                        :value="inputValue || ''"
                        is-calendar
                        readonly
                        class="user-search-filters__from-to-date"
                        @click.native="togglePopover({ placement: 'auto-start' })"
                    />
                </template>
            </vc-date-picker>
        </div>
        <ModelMultiAutoComplete
            v-loading.small="loading.statusesList"
            v-if="showInput"
            class="user-search-filters__projects-statuses"
            label="Статус участника"
            itemValue="id"
            itemText="name"
            v-model="filters.nominations.participantStatuses"
            :selected="getStatusesSelected"
            :search="statusesList"
            @debounce-end="getStatuses"
        />

        <h4 class="title">Обучение на курсах РСВ</h4>

        <div class="user-search-filters__from-to-wrapper">
            <vc-date-picker
                v-model="filters.course.courseDateFrom"
                :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                }"
            >
                <template v-slot="{ inputValue, togglePopover }">
                    <ModelString
                        label="С"
                        :value="inputValue || ''"
                        is-calendar
                        readonly
                        class="user-search-filters__from-to-date"
                        @click.native="togglePopover({ placement: 'auto-start' })"
                    />
                </template>
            </vc-date-picker>
            <vc-date-picker
                v-model="filters.course.courseDateTo"
                :model-config="{
                    type: 'string',
                    mask: 'YYYY-MM-DD',
                }"
            >
                <template v-slot="{ inputValue, togglePopover }">
                    <ModelString
                        label="По"
                        :value="inputValue || ''"
                        is-calendar
                        readonly
                        class="user-search-filters__from-to-date"
                        @click.native="togglePopover({ placement: 'auto-start' })"
                    />
                </template>
            </vc-date-picker>
        </div>
        <ModelMultiAutoComplete
            v-loading.small="loading.courseOrganizerList"
            v-if="showInput"
            class="user-search-filters__projects-types"
            label="Организатор курса"
            itemValue="id"
            itemText="name"
            v-model="filters.course.foreign_institutes_id"
            :selected="filters.course.foreign_institutes_id"
            :search="courseOrganizerList"
            @debounce-end="getCourseOrganizer"
            use-object
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.eventList"
            v-if="showInput"
            class="user-search-filters__projects-project"
            label="Наименование курса"
            itemValue="id"
            itemText="name"
            v-model="filters.course.event_id"
            :selected="filters.course.event_id"
            :search="eventList"
            hide-debounce-loading
            @debounce-end="getEvents"
            use-object
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.eventList"
            v-if="showInput"
            class="user-search-filters__projects-project user-search-filters__projects-project--exclude"
            label="Исключить курс"
            itemValue="id"
            itemText="name"
            v-model="filters.course.excludeEventId"
            :selected="filters.course.excludeEventId"
            :search="eventList"
            hide-debounce-loading
            @debounce-end="getEvents"
            use-object
        />

        <ModelMultiAutoComplete
            v-loading.small="loading.courseStatusList"
            v-if="showInput"
            class="user-search-filters__projects-season"
            label="Статус участия"
            itemValue="id"
            itemText="name"
            v-model="filters.course.courseStatus"
            :selected="filters.course.courseStatus"
            :search="courseStatusList"
            @debounce-end="getCourseStatus"
            use-object
        />

        <h4 class="title">Карьера</h4>
        <ModelMultiAutoComplete
            v-loading.small="loading.activitiesList"
            v-if="showInput"
            class="user-search-filters__career-activity"
            label="Сфера деятельности"
            itemValue="id"
            itemText="name"
            v-model="filters.profile.activities"
            :selected="getActivitiesSelected"
            :search="activitiesList"
            @debounce-end="getActivities"
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.skillsList"
            v-if="showInput"
            class="user-search-filters__career-skills"
            label="Профессиональные навыки"
            itemValue="id"
            itemText="name"
            v-model="filters.profile.skills"
            :selected="getSkillsSelected"
            :search="skillsList"
            @debounce-end="getSkills"
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.levelsList"
            v-if="showInput"
            class="user-search-filters__career-level"
            label="Уровень должности"
            itemValue="id"
            itemText="name"
            v-model="filters.career.levels"
            :selected="getLevelsSelected"
            :search="levelsList"
            @debounce-end="getLevels"
        />

        <h4 class="title">Подтвержденные компетенции</h4>
        <ModelMultiAutoComplete
            v-loading.small="loading.competenceList"
            v-if="showInput"
            class="user-search-filters__competence-type"
            label="Компетенция"
            itemValue="id"
            itemText="name"
            v-model="filters.progress.competence"
            :selected="getCompetenceSelected"
            :search="competenceList"
            @debounce-end="getCompetence"
        />
        <ModelMultiAutoComplete
            v-if="showInput"
            class="user-search-filters__competence-level"
            label="Уровень компетенции"
            itemValue="field_value"
            itemText="name"
            :disabled="!filters.progress.competence.length"
            v-model="filters.progress.levels"
            :selected="getCompetenceLevelsSelected"
            :search="competenceLevelsList"
        />

        <div>
            <h4 class="user-search-filters__from-to-title">Желаемый уровень зарплаты</h4>
            <div class="user-search-filters__from-to-wrapper">
                <ModelString v-if="showInput" label="От" v-model="filters.profile.fromSalary" type="number" />
                <ModelString v-if="showInput" label="До" v-model="filters.profile.toSalary" type="number" />
            </div>
        </div>

        <ModelMultiAutoComplete
            v-loading.small="loading.jobStatusesList"
            v-if="showInput"
            class="user-search-filters__career-status"
            label="Статус поиска работы"
            itemValue="id"
            itemText="name"
            v-model="filters.profile.jobStatuses"
            :selected="getJobStatusesSelected"
            :search="jobStatusesList"
            @debounce-end="getJobStatuses"
        />

        <YesNoAnyInput title="Опыт работы на государственной службе" v-model="filters.profile.government" />

        <h4 class="title">Образование</h4>
        <ModelMultiAutoComplete
            v-loading.small="loading.educationLevelsList"
            v-if="showInput"
            class="user-search-filters__education-level"
            label="Уровень образования"
            itemValue="id"
            itemText="name"
            v-model="filters.education.educationLevels"
            :selected="getEducationLevelsSelected"
            :search="educationLevelsList"
            @debounce-end="getEducationLevels"
        />
        <ModelMultiAutoComplete
            v-if="showInput"
            class="user-search-filters__education-place"
            label="Учебное заведение"
            itemValue="name"
            itemText="name"
            v-model="filters.education.educationPlaces"
            :selected="getEducationPlacesSelected"
            :search="educationPlacesList"
            @debounce-end="getEducationPlaces"
            noInputText="Введите название учебного заведения"
            noResultText="Учебное заведение не найдено"
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.educationSpecialtiesList"
            v-if="showInput"
            class="user-search-filters__education-specialty"
            label="Специальность"
            itemValue="id"
            itemText="name"
            v-model="filters.education.educationSpecialties"
            :selected="getEducationSpecialtiesSelected"
            :search="educationSpecialtiesList"
            @debounce-end="getEducationSpecialties"
        />
        <ModelMultiAutoComplete
            v-loading.small="loading.educationDegreesList"
            v-if="showInput"
            class="user-search-filters__education-degree"
            label="Ученая степень"
            itemValue="id"
            itemText="name"
            v-model="filters.education.educationDegrees"
            :selected="getEducationDegreesSelected"
            :search="educationDegreesList"
            @debounce-end="getEducationDegrees"
        />

        <h4 class="title">Знание языков</h4>
        <div class="user-search-filters__other-language">
            <ModelAutoComplete
                v-loading.small="loading.languageList"
                v-if="showInput"
                class="user-search-filters__other-language"
                label="Язык"
                :value="filters.language.language"
                @change="filters.language.language = $event"
                :vizKeyPath="[['field_value']]"
                :valKeyPath="[['id']]"
                :items="languageList"
                @debounce-end="getLanguages"
                @clear="filters.language.language = null"
                with-clear
            />
            <ModelAutoComplete
                v-loading.small="loading.languageLevelsList"
                v-if="showInput"
                class="user-search-filters__other-language-level"
                label="Уровень владения"
                :value="filters.language.languageLevel"
                @change="filters.language.languageLevel = $event"
                :vizKeyPath="[['field_value']]"
                :valKeyPath="[['id']]"
                :items="languageLevelsList"
                @debounce-end="getLanguageLevels"
                @clear="filters.language.languageLevel = null"
                with-clear
            />
        </div>
        <ModelMultiAutoComplete
            v-loading.small="loading.liftList"
            v-if="showInput"
            class="user-search-filters__other-lift"
            label="Социальный лифт"
            itemValue="id"
            itemText="name"
            v-model="filters.profile.lifts"
            :selected="getLiftSelected"
            :search="liftList"
            @debounce-end="getLift"
        />
        <div class="user-search-filters__other-social-work">
            <YesNoAnyInput title="Участие в социальной работе" v-model="filters.profile.socialWork" />
        </div>
        <div class="user-search-filters__other-volunteer-work">
            <YesNoAnyInput title="Участие в волонтерских программах" v-model="filters.profile.volunteerWork" />
        </div>

        <button @click="clearFilters" class="button button-red button-outline">Очистить</button>
    </div>
</template>

<script>
import ModelMultiAutoComplete from '@/components/UI/models/ModelMultiAutoComplete';
import ModelSwitch from '@/components/UI/models/ModelSwitch';
import ModelString from '@/components/UI/models/ModelString';
import ModelAutoComplete from '@/components/UI/models/ModelAutoComplete';
import { get, post, qs } from '@/tools/http';
import { mapGetters, mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { getDefaultFilters } from './filters';

import YesNoAnyInput from '@/components/UI/inputs/YesNoAnyInput.vue';
import debounce from '@/tools/debounce';

export default {
    name: 'UserSearchFilters',

    components: {
        YesNoAnyInput,
        ModelMultiAutoComplete,
        ModelString,
        ModelAutoComplete,
        ModelSwitch,
    },

    props: {
        filtersData: {
            type: Object,
        },
        isFavorite: {
            type: Boolean,
        },
        withDrafts: {
            type: Boolean,
        },
        isImportantFieldsFilled: {
            type: Boolean,
        },
    },

    data() {
        return {
            disabled: {
                nominationList: false,
                excludeSeasonsList: false,
            },

            courseStatusOptions: [
                {
                    id: 'completed_event',
                    name: 'Пройдено',
                },
                {
                    id: 'subscribed',
                    name: 'Подписан',
                },
                {
                    id: 'confirmed_request',
                    name: 'Записан',
                },
                {
                    id: 'missed_event',
                    name: 'Пропущено',
                },
                {
                    id: 'admin_sent_request',
                    name: 'Приглашение отправлено администратором ',
                },
                {
                    id: 'admin_refused_request',
                    name: 'Приглашение отклонено администратором',
                },
                {
                    id: 'user_refused_request',
                    name: 'Приглашение отклонено пользователем',
                },
                {
                    id: 'user_sent_request',
                    name: 'Заявка отправлена пользователем ',
                },
            ],

            loading: {
                projectsList: true,
                rootProjectsList: true,
                statusesList: true,
                activitiesList: true,
                skillsList: true,
                levelsList: true,
                jobStatusesList: true,
                educationLevelsList: true,
                educationSpecialtiesList: true,
                educationDegreesList: true,
                projectsTypesList: true,
                courseOrganizerList: true,
                eventList: true,
                courseStatusList: true,
                competenceList: true,
                languageList: true,
                languageLevelsList: true,
                liftList: true,
                nominationList: true,
                excludeSeasonsList: true,
            },
            filters: getDefaultFilters(),
            languageList: [],
            languageLevelsList: [],
            autoCompleteAddresses: [],
            activitiesList: [],
            liftList: [],
            competenceList: [],
            competenceLevelsList: [
                {
                    field_value: 'basic',
                    name: 'Начальный',
                },
                {
                    field_value: 'intermediate',
                    name: 'Средний',
                },
                {
                    field_value: 'advanced',
                    name: 'Высокий',
                },
            ],
            educationDegreesList: [],
            educationLevelsList: [],
            educationPlacesList: [],
            educationSpecialtiesList: [],
            skillsList: [],
            jobStatusesList: [],
            levelsList: [],
            projectsTypesList: [],
            projectsTypesListCompleted: [],
            courseOrganizerList: [],
            courseOrganizerListCompleted: [],
            courseStatusList: [],
            courseStatusListCompleted: [],
            eventList: [],
            eventListCompleted: [],
            projectsList: [],
            projectsListCompleted: [],
            rootProjectsList: [],
            rootProjectsListCompleted: [],
            rootProjectsMap: {},
            rootProjectsTypesMap: {},
            statusesList: [],
            autoCompleteCountry: [],
            showInput: true,
            nominationList: [],
            nominationListCompleted: [],
            excludeSeasonsList: [],
            excludeSeasonsListCompleted: [],
        };
    },

    watch: {
        filtersData: {
            handler(newVal) {
                this.initFiltersData(newVal);
            },
            deep: true,
        },
        'filters.nominations.projects': {
            async handler(newVal, oldVal) {
                if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
                    if (!newVal.length) {
                        this.filters.nominations.projectRegisteredAtDateFrom = null;
                        this.filters.nominations.projectRegisteredAtDateTo = null;
                    }

                    debounce(
                        async () => {
                            await this.initNominations();
                        },
                        200,
                        false,
                        'user-search-filter-projects-update'
                    )();
                }
            },
            deep: true,
        },
        'filters.nominations.excludeProjects': {
            async handler(newVal, oldVal) {
                if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
                    debounce(
                        async () => {
                            await this.initExcludeSeasons();
                        },
                        200,
                        false,
                        'user-search-filter-exclude-seasons-update'
                    )();
                }
            },
            deep: true,
        },
        'filters.nominations.seasons': {
            async handler(newVal, oldVal) {
                if (JSON.stringify(oldVal) !== JSON.stringify(newVal) && !newVal.length) {
                    this.filters.nominations.nominationRegisteredAtDateFrom = null;
                    this.filters.nominations.nominationRegisteredAtDateTo = null;
                }
            },
            deep: true,
        },

        'filters.nominations.rootProjects': {
            async handler(newVal, oldVal) {
                if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
                    debounce(
                        async () => {
                            this.loading.projectsList = true;
                            this.loading.projectsTypesList = true;
                            await this.updateRootProjectsMap();
                            this.loading.projectsTypesList = false;
                            this.loading.projectsList = false;
                        },
                        200,
                        false,
                        'user-search-filter-root-projects-update'
                    )();
                }
            },
            deep: true,
        },

        'filters.course.foreign_institutes_id': {
            async handler() {
                await this.reqEventList();
            },
        },

        'filters.course.event_id': {
            handler() {
                if (this.filters.course.event_id.length === 0) {
                    this.filters.course.courseStatus = [];
                }
            },
            deep: true,
        },

        filters: {
            handler(oldVal, newVal) {
                debounce(
                    async () => {
                        await this.submitFilters();
                    },
                    200,
                    false,
                    'user-search-filter'
                )();
            },
            deep: true,
        },
    },

    computed: {
        ...mapGetters(['dictionaryByType', 'getCompetenceList']),
        ...mapGetters('data', ['getRegistryItems']),

        projectsInSelectedRootProjects() {
            return [
                ...new Set(this.filters.nominations.rootProjects.map((rp) => this.rootProjectsMap[rp] || []).flat()),
            ];
        },
        projectTypesInSelectedRootProjects() {
            return [
                ...new Set(
                    this.filters.nominations.rootProjects.map((rp) => this.rootProjectsTypesMap[rp] || []).flat()
                ),
            ];
        },

        projectsListWithTypeFilter() {
            const types = this.filters.nominations.projectsTypes;
            const selected = this.filters.nominations.projects || [];

            const projectsInSelectedGroups = this.projectsInSelectedRootProjects;

            if ((!types || types.length === 0) && !projectsInSelectedGroups.length) {
                return this.projectsList;
            }

            return this.projectsList.filter((item) => {
                if (selected.includes(item.id)) {
                    return true;
                }

                const isSpk2 = `${parseInt(item.id)}` !== `${item.id}`;

                if (projectsInSelectedGroups.length && (!projectsInSelectedGroups.includes(item.id) || !isSpk2)) {
                    return false;
                }

                if (types.length) {
                    if (!isSpk2) {
                        return types.find((i) => {
                            if (i.field_name === 'project') {
                                return ['project', 'internship'].includes(item.type);
                            } else if (i.field_name === 'contest') {
                                return ['contest', 'contests'].includes(item.type);
                            } else if (i.field_name === 'facetoface_event') {
                                return ['facetoface_event', 'events'].includes(item.type);
                            }

                            return i.field_name === item.type;
                        });
                    } else {
                        return types.find((i) => i.field_id === item.type);
                    }
                }

                return true;
            });
        },

        getRootProjectsSelected() {
            if (!(this.filters.nominations.rootProjects || []).length) {
                return [];
            }

            return [...(this.rootProjectsListCompleted || [])].filter((i) => {
                if (this.filters.nominations.rootProjects.includes(i.id)) {
                    return i;
                }
            });
        },
        getProjectsSelected() {
            if (!(this.filters.nominations.projects || []).length) {
                return [];
            }

            return [...(this.projectsListCompleted || [])].filter((i) => {
                if (this.filters.nominations.projects.includes(i.id)) {
                    return i;
                }
            });
        },
        getExcludeProjectsSelected() {
            if (!(this.filters.nominations.excludeProjects || []).length) {
                return [];
            }

            return [...(this.projectsListCompleted || [])].filter((i) => {
                if (this.filters.nominations.excludeProjects.includes(i.id)) {
                    return i;
                }
            });
        },
        getSeasonSelected() {
            if (!(this.filters.nominations.seasons || []).length) {
                return [];
            }

            return [...(this.nominationListCompleted || [])].filter((i) => {
                if (this.filters.nominations.seasons.includes(i.id)) {
                    return i;
                }
            });
        },
        getExcludeSeasonsSelected() {
            if (!(this.filters.nominations.excludeSeasonsList || []).length) {
                return [];
            }

            return [...(this.excludeSeasonsListCompleted || [])].filter((i) => {
                if (this.filters.nominations.excludeSeasonsList.includes(i.id)) {
                    return i;
                }
            });
        },
        getProjectsTypesFiltered() {
            const projectsTypesInSelectedGroups = this.projectTypesInSelectedRootProjects;
            const selected = this.filters.nominations.projectsTypes.map((v) => v.id);

            return this.projectsTypesList.filter((t) => {
                if (selected.length && selected.includes(t.id)) {
                    return true;
                }

                return !projectsTypesInSelectedGroups.length || projectsTypesInSelectedGroups.includes(t.id);
            });
        },

        getStatusesSelected() {
            return this.getDictFilter('stage_history', '', 'id', this.filters.nominations.participantStatuses, true);
        },
        getCompetenceSelected() {
            return this.getDictFilter('competence', '', 'id', this.filters.progress.competence, true);
        },
        getCompetenceLevelsSelected() {
            let dict = this.competenceLevelsList;
            const selected = this.filters.progress.levels;
            dict = selected && selected.length ? dict.filter((v) => selected.includes(v.field_value)) : [];

            return dict.map((v) => ({
                field_value: v.field_value,
                name: v.name,
            }));
        },
        getActivitiesSelected() {
            return this.getDictFilter('industries', '', 'id', this.filters.profile.activities, true);
        },
        getLevelsSelected() {
            return this.getDictFilter('position_level', '', 'id', this.filters.career.levels, true);
        },
        getJobStatusesSelected() {
            return this.getDictFilter('job_status', '', 'id', this.filters.profile.jobStatuses, true);
        },
        getEducationDegreesSelected() {
            return this.getDictFilter('academic_degree', '', 'id', this.filters.education.educationDegrees, true);
        },
        getLiftSelected() {
            return this.getDictFilter('social_lift', '', 'id', this.filters.profile.lifts, true);
        },
        getEducationLevelsSelected() {
            return this.getDictFilter('education_level', '', 'id', this.filters.education.educationLevels, true);
        },
        getEducationSpecialtiesSelected() {
            return this.getDictFilter(
                'education_specialities',
                '',
                'field_value',
                this.filters.education.educationSpecialties,
                true
            );
        },
        getSkillsSelected() {
            return this.getDictFilter('key_skills', '', 'id', this.filters.profile.skills, true);
        },
        getEducationPlacesSelected() {
            return this.filters.education.educationPlaces.map((name) => ({ name }));
        },

        hasOldProjects() {
            return this.filters.nominations.projects.find((v) => parseInt(v).toString() === v.toString());
        },
    },
    async created() {
        const getDictMap = (dictType, field = 'id') =>
            this.dictionaryByType(dictType).map((v) => ({
                id: v[field].toString(),
                name: v.field_value,
                field_id: v.id,
                field_value: v.field_value,
                field_name: v.field_name,
            }));

        const errorHandler = (e) => console.error('Ошибка загрузки фильтров', e);

        try {
            const updateRootProjectMapPromise = this.updateRootProjectsMap();

            Promise.all([
                this.loadAllProjectsList(),
                this.loadSeasons({
                    perPage: 9999,
                    fetchOnly: true,
                    withoutPagination: true,
                    withNoPublication: true,
                }),
            ])
                .then(async (result) => {
                    await updateRootProjectMapPromise;

                    this.projectsListCompleted = [
                        ...(result[0] || []).map((i) => ({
                            name: i.name || `Проект СПК 2 - ${i.id}`,
                            id: i.id,
                            type: i.type,
                            nominations: i.nominations,
                        })),
                        ...(result[1].seasons || []).map((i) => ({
                            name: i.name || i.title || `Проект (old) - #${i.id}`,
                            id: i.id.toString(),
                            type: i.type,
                        })),
                    ];
                    this.projectsList = [...this.projectsListCompleted];

                    this.loading.projectsList = false;

                    this.initNominations().catch(errorHandler);
                    this.initExcludeSeasons().catch(errorHandler);
                })
                .catch(errorHandler);

            this.loadRootProjectsList().then((result) => {
                this.loading.rootProjectsList = false;
                this.rootProjectsList = this.rootProjectsListCompleted = [...result];
            });

            this.loadDictionaryItems('stage_history')
                .then(() => {
                    this.loading.statusesList = false;
                    this.statusesList = getDictMap('stage_history');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('industries')
                .then(() => {
                    this.loading.activitiesList = false;
                    this.activitiesList = getDictMap('industries', 'id');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('key_skills')
                .then(() => {
                    this.loading.skillsList = false;
                    this.skillsList = getDictMap('key_skills', 'id');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('position_level')
                .then(() => {
                    this.loading.levelsList = false;
                    this.levelsList = getDictMap('position_level');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('job_status')
                .then(() => {
                    this.loading.jobStatusesList = false;
                    this.jobStatusesList = getDictMap('job_status');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('education_level')
                .then(() => {
                    this.loading.educationLevelsList = false;
                    this.educationLevelsList = getDictMap('education_level');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('education_specialities')
                .then(() => {
                    this.loading.educationSpecialtiesList = false;
                    this.educationSpecialtiesList = getDictMap('education_specialities', 'field_value');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('academic_degree')
                .then(() => {
                    this.loading.educationDegreesList = false;
                    this.educationDegreesList = getDictMap('academic_degree');
                })
                .catch(errorHandler);
            this.loadDictionaryItems('spk_project_type', true)
                .then(async () => {
                    await updateRootProjectMapPromise;
                    this.projectsTypesList = getDictMap('spk_project_type');
                    this.loading.projectsTypesList = false;
                })
                .catch(errorHandler);

            this.loadDictionaryItems('organization_type', true)
                .then(async () => {
                    const organizationTypes = getDictMap('organization_type');
                    const organizationType = organizationTypes.find((type) => type.field_name === 'course_organizer');
                    const result = await get(
                        'progress',
                        `institutes?filter[foreignTypeId][]=${organizationType.field_id}`
                    );
                    this.courseOrganizerListCompleted = result.institutes.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }));

                    this.courseOrganizerList = [...this.courseOrganizerListCompleted];
                    this.loading.courseOrganizerList = false;
                })
                .catch(errorHandler);

            this.reqEventList();

            this.loadCourseStatus();

            this.loadDictionaryItems('social_lift')
                .then(() => {
                    this.loading.liftList = false;
                    this.liftList = getDictMap('social_lift');
                })
                .catch(errorHandler);

            this.loadDictionaryItems('languages')
                .then(() => {
                    this.loading.languageList = false;
                    this.languageList = this.dictionaryByType('languages');
                })
                .catch(errorHandler);

            this.loadDictionaryItems('level_language')
                .then(() => {
                    this.loading.languageLevelsList = false;
                    this.languageLevelsList = this.dictionaryByType('level_language');
                })
                .catch(errorHandler);

            this.loadProgressCompetence()
                .then(() => {
                    this.loading.competenceList = false;
                    this.competenceList = this.getCompetenceList;
                })
                .catch(errorHandler);

            this.loadAllProgressCompetence();

            // Ожидаем загрузку данных для корректной отработки fetch на бэке nuxt
            await new Promise((resolve) => {
                const check = () =>
                    setTimeout(() => {
                        for (const i in this.loading) {
                            if (this.loading[i]) {
                                check();
                                return;
                            }
                        }

                        resolve();
                    }, 10);

                check();
            });
        } catch (e) {
            errorHandler(e);
        }
    },

    beforeMount() {
        const filters = getDefaultFilters();
        for (const type in this.filtersData) {
            for (const key in this.filtersData[type]) {
                filters[type][key] = this.filtersData[type][key];
            }
        }

        this.initFiltersData(filters);
    },
    methods: {
        ...mapActions([
            'loadAllProjectsList',
            'loadRootProjectsList',
            'fetchAllProjectsList',
            'loadRootProjectsList',
            'loadDictionaryItems',
            'loadProgressCompetence',
            'loadAllProgressCompetence',
            'dictionaryAutocomplete',
        ]),
        ...mapActions('projects', ['loadSeasons', 'loadSeasonCached']),

        async updateRootProjectsMap() {
            const ids = this.filters.nominations.rootProjects.filter(
                (rp) => this.rootProjectsMap[rp] === undefined || this.rootProjectsTypesMap[rp] === undefined
            );

            if (ids.length) {
                const promises = [];

                for (const projectGroupId of ids) {
                    promises.push(
                        this.fetchAllProjectsList({ projectGroupId }).then((projects) => {
                            this.$set(this.rootProjectsMap, projectGroupId, [
                                ...new Set((projects || []).map((p) => p.id)),
                            ]);
                            this.$set(this.rootProjectsTypesMap, projectGroupId, [
                                ...new Set((projects || []).map((p) => `${p.type}`)),
                            ]);
                        })
                    );
                }

                await Promise.all(promises);
            }
        },

        async initNominations() {
            this.loading.nominationList = true;

            if (this.loading.projectsList) {
                // проекты еще не загружены, ждем догрузки проектов
                await new Promise((resolve) => {
                    const interval = setInterval(() => {
                        if (!this.loading.projectsList) {
                            clearInterval(interval);
                            resolve();
                        }
                    }, 10);
                });
            }

            const projects = this.filters.nominations.projects;

            if (projects.length === 0) {
                if (this.filters.nominations.seasons.length !== 0) {
                    this.filters.nominations.seasons = [];
                }

                this.disabled.nominationList = true;
                this.loading.nominationList = false;

                return;
            }

            this.loading.nominationList = true;
            this.disabled.nominationList = false;

            const spk1 = projects.filter((v) => parseInt(v).toString() === v.toString());
            const spk2 = projects.filter((v) => !spk1.includes(v));

            const promises = [];
            const nominations = [];

            if (spk1.length > 0) {
                spk1.forEach((v) => {
                    promises.push(new Promise(async (r) => r([v, await this.loadSeasonCached(v)])));
                });
            }

            if (spk2.length > 0) {
                this.projectsListCompleted.forEach((v) => {
                    if (spk2.includes(v.id)) {
                        nominations.push(
                            ...(v.nominations || []).map((vv) => ({
                                id: vv.id,
                                name: `${vv.name} (${v.name})`,
                            }))
                        );
                    }
                });
            }

            if (promises.length) {
                const res = await Promise.all(promises);

                for (const r of res) {
                    nominations.push(
                        ...(r[1].nominations || []).map((vv) => ({
                            id: vv.id.toString(),
                            name: `${vv.name} (${r[1].name})`,
                        }))
                    );
                }
            }

            this.nominationListCompleted = nominations;
            this.nominationList = [...nominations];

            const nominationIDs = nominations.map((v) => v.id);

            this.filters.nominations.seasons = this.filters.nominations.seasons.filter((v) =>
                nominationIDs.includes(v.toString())
            );

            this.loading.nominationList = false;
        },

        async initExcludeSeasons() {
            this.loading.excludeSeasonsList = true;

            if (this.loading.excludeProjects) {
                await new Promise((resolve) => {
                    const interval = setInterval(() => {
                        if (!this.loading.excludeProjects) {
                            clearInterval(interval);
                            resolve();
                        }
                    }, 10);
                });
            }

            const projects = this.filters.nominations.excludeProjects;

            if (projects.length === 0) {
                if (this.filters.nominations.excludeSeasonsList.length !== 0) {
                    this.filters.nominations.excludeSeasonsList = [];
                }

                this.disabled.excludeSeasonsList = true;
                this.loading.excludeSeasonsList = false;

                return;
            }

            this.loading.excludeSeasonsList = true;
            this.disabled.excludeSeasonsList = false;

            const spk1 = projects.filter((v) => parseInt(v).toString() === v.toString());
            const spk2 = projects.filter((v) => !spk1.includes(v));

            const promises = [];
            const nominations = [];

            if (spk1.length > 0) {
                spk1.forEach((v) => {
                    promises.push(new Promise(async (r) => r([v, await this.loadSeasonCached(v)])));
                });
            }

            if (spk2.length > 0) {
                this.projectsListCompleted.forEach((v) => {
                    if (spk2.includes(v.id)) {
                        nominations.push(
                            ...(v.nominations || []).map((vv) => ({
                                id: vv.id,
                                name: `${vv.name} (${v.name})`,
                            }))
                        );
                    }
                });
            }

            if (promises.length) {
                const res = await Promise.all(promises);

                for (const r of res) {
                    nominations.push(
                        ...(r[1].nominations || []).map((vv) => ({
                            id: vv.id.toString(),
                            name: `${vv.name} (${r[1].name})`,
                        }))
                    );
                }
            }

            this.excludeSeasonsListCompleted = nominations;
            this.excludeSeasonsList = [...nominations];

            const nominationIDs = nominations.map((v) => v.id);

            this.filters.nominations.excludeSeasonsList = this.filters.nominations.excludeSeasonsList.filter((v) =>
                nominationIDs.includes(v.toString())
            );

            this.loading.excludeSeasonsList = false;
        },

        initFiltersData(newVal) {
            if (!newVal) {
                return;
            }

            if (isEqual(newVal, this.filters)) {
                return;
            }
            if (newVal.favorite_membership.status === 'true') {
                newVal.favorite_membership.status = true;
            } else if (newVal.favorite_membership.status === 'false') {
                newVal.favorite_membership.status = false;
            }
            if (newVal.profile.withDrafts === 'true') {
                newVal.profile.withDrafts = true;
            } else if (newVal.profile.withDrafts === 'false') {
                newVal.profile.withDrafts = false;
            }
            for (const type in newVal) {
                if (this.filters[type] === undefined) {
                    this.$set(this.filters, type, {});
                }
                for (const key in newVal[type]) {
                    this.$set(this.filters[type], key, newVal[type][key]);
                }
            }
            if (this.filters.progress.competence.length) {
                this.filters.progress.competence = this.filters.progress.competence.map((item) => {
                    return +item;
                });
            }
        },

        async loadAddresses(inputObj) {
            let postParams = [
                'dadata',
                'search',
                qs({ query: inputObj.value, type: 'address' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];

            let res = await post(...postParams);

            return res;
        },
        clearFilters() {
            this.showInput = false;

            this.$nextTick(() => {
                this.showInput = true;
            });
            const newFilters = getDefaultFilters();
            if (!this.isFavorite) {
                newFilters.favorite_membership.isFavorite = true;
                newFilters.favorite_membership.status = true;
            }
            for (const key in newFilters) {
                this.$set(this.filters, key, newFilters[key]);
            }

            this.submitFilters();
        },
        submitFilters() {
            this.$emit('submit', cloneDeep(this.filters));
        },
        async loadCountry(inputObj) {
            let postParams = [
                'dadata',
                'search',
                qs({ query: inputObj.value, type: 'country' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            return res;
        },

        async reqEventList(search = '') {
            this.loading.eventList = true;

            let queryParams =
                '?limit=100&filter[private_all]=true&filter[status][]=public&filter[status][]=private&fields[]=foreignInstitutesId&fields[]=name&filter[type]=course';

            for (const item of this.filters.course.foreign_institutes_id) {
                queryParams = queryParams + `&filter[foreignInstitutesId][]=${item.id}`;
            }

            if (search) {
                queryParams += `&filter[name]=${search}`;
            }

            const res = await get('event', `event/all/lite${queryParams}`);

            this.eventListCompleted = res.events.map((event) => ({
                id: event.id,
                name: event.name,
            }));

            this.eventList = [...this.eventListCompleted];
            this.loading.eventList = false;
        },

        loadCourseStatus() {
            this.courseStatusListCompleted = [...this.courseStatusOptions];
            this.courseStatusList = [...this.courseStatusListCompleted];
            this.loading.courseStatusList = false;
        },

        getDictFilter(type, val, idField, selected, selectedOnly = false) {
            let dict = type === 'competence' ? this.getCompetenceList : this.dictionaryByType(type);
            const lc = val.toLowerCase();

            if (selectedOnly) {
                dict =
                    selected && selected.length
                        ? dict.filter((v) =>
                              type === 'competence'
                                  ? selected.includes(v[idField])
                                  : selected.includes(v[idField].toString())
                          )
                        : [];
            } else if (lc) {
                dict = dict.filter((v) =>
                    type === 'competence'
                        ? v.name.toLowerCase().includes(lc)
                        : v.field_value.toLowerCase().includes(lc) || selected.includes(v[idField].toString())
                );
            }
            return type === 'competence'
                ? dict.map((v) => ({
                      id: v.id,
                      name: v.name,
                  }))
                : dict.map((v) => ({
                      id: v[idField].toString(),
                      name: v.field_value,
                      field_id: v.id,
                      field_value: v.field_value,
                      field_name: v.field_name,
                  }));
        },

        getRootProjects(inputObj) {
            this.rootProjectsList = [...(this.rootProjectsListCompleted || [])].filter((i) => {
                if (
                    !inputObj.value ||
                    i.name.toLowerCase().includes(inputObj.value.toLowerCase()) ||
                    this.filters.nominations.rootProjects.includes(i.id)
                ) {
                    return i;
                }
            });
        },

        getProjects(inputObj) {
            const projectsSelected = this.filters.nominations.projects;
            const projectsInSelectedGroups = this.filters.nominations.rootProjects
                .map((rp) => this.rootProjectsMap[rp] || [])
                .flat();

            this.projectsList = [...(this.projectsListCompleted || [])].filter((i) => {
                if (projectsSelected.includes(i.id)) {
                    return i;
                }

                if (
                    (!projectsInSelectedGroups.length || projectsInSelectedGroups.includes(i.id)) &&
                    (!inputObj.value || i.name.toLowerCase().includes(inputObj.value.toLowerCase()))
                ) {
                    return i;
                }
            });
        },

        getCourseOrganizer(inputObj) {
            const filtredData = this.courseOrganizerListCompleted.filter(
                (organizer) =>
                    organizer.name.toLowerCase().includes(inputObj.value.toLowerCase()) ||
                    organizer.id == inputObj.value
            );

            this.courseOrganizerList = filtredData.length ? filtredData : [...this.courseOrganizerListCompleted];
        },

        async getEvents(inputObj) {
            await this.reqEventList(inputObj.value);
            this.eventList = this.eventListCompleted;
        },

        getCourseStatus(inputObj) {
            const filtredData = this.courseStatusListCompleted.filter(
                (event) => event.name.toLowerCase().includes(inputObj.value.toLowerCase()) || event.id == inputObj.value
            );

            this.courseStatusList = filtredData.length ? filtredData : [...this.courseStatusListCompleted];
        },

        getSeasons(inputObj) {
            this.nominationList = [...(this.nominationListCompleted || [])].filter((i) => {
                if (
                    !inputObj.value ||
                    i.name.toLowerCase().includes(inputObj.value.toLowerCase()) ||
                    this.filters.nominations.seasons.includes(i.id)
                ) {
                    return i;
                }
            });
        },

        getExcludeSeasons(inputObj) {
            this.excludeSeasonsList = [...(this.excludeSeasonsListCompleted || [])].filter((i) => {
                if (
                    !inputObj.value ||
                    i.name.toLowerCase().includes(inputObj.value.toLowerCase()) ||
                    this.filters.nominations.excludeSeasonsList.includes(i.id)
                ) {
                    return i;
                }
            });
        },

        getProjectsTypes(inputObj) {
            const dict = this.dictionaryByType('spk_project_type');

            const selected = this.filters.nominations.projectsTypes.map((v) => v.id);

            this.projectsTypesList = [...dict]
                .filter((t) => {
                    return (
                        (selected.length && selected.includes(`${t.id}`)) ||
                        !inputObj.value ||
                        t.field_value.toLowerCase().includes(inputObj.value.toLowerCase())
                    );
                })
                .map((v) => ({
                    id: v.id.toString(),
                    name: v.field_value,
                    field_id: v.id,
                    field_value: v.field_value,
                    field_name: v.field_name,
                }));
        },
        getStatuses(inputObj) {
            this.statusesList = this.getDictFilter(
                'stage_history',
                inputObj.value,
                'id',
                this.filters.nominations.participantStatuses
            );
        },
        getActivities(inputObj) {
            this.activitiesList = this.getDictFilter(
                'industries',
                inputObj.value,
                'id',
                this.filters.profile.activities
            );
        },
        getCompetence(inputObj) {
            this.competenceList = this.getDictFilter(
                'competence',
                inputObj.value,
                'id',
                this.filters.progress.competence
            );
        },
        getLevels(inputObj) {
            this.levelsList = this.getDictFilter('position_level', inputObj.value, 'id', this.filters.career.levels);
        },
        getJobStatuses(inputObj) {
            this.jobStatusesList = this.getDictFilter(
                'job_status',
                inputObj.value,
                'id',
                this.filters.profile.jobStatuses
            );
        },
        getEducationDegrees(inputObj) {
            this.educationDegreesList = this.getDictFilter(
                'academic_degree',
                inputObj.value,
                'id',
                this.filters.education.educationDegrees
            );
        },
        getLift(inputObj) {
            this.liftList = this.getDictFilter('social_lift', inputObj.value, 'id', this.filters.profile.lifts);
        },
        getEducationLevels(inputObj) {
            this.educationLevelsList = this.getDictFilter(
                'education_level',
                inputObj.value,
                'id',
                this.filters.education.educationLevels
            );
        },
        async getEducationPlaces(inputObj) {
            this.educationPlacesList = (
                await this.dictionaryAutocomplete({
                    type: 'educational_institutions',
                    search: inputObj.value,
                })
            ).map((i) => {
                return { name: i.field_value, id: i.id };
            });
        },
        getEducationSpecialties(inputObj) {
            this.educationSpecialtiesList = this.getDictFilter(
                'education_specialities',
                inputObj.value,
                'field_value',
                this.filters.education.educationSpecialties
            );
        },
        getSkills(inputObj) {
            this.skillsList = this.getDictFilter('key_skills', inputObj.value, 'id', this.filters.profile.skills);
        },
        getLanguages(inputObj) {
            this.languageList = this.dictionaryByType('languages').filter((i) => {
                return (
                    !inputObj.value ||
                    i.field_value.toLowerCase().includes(inputObj.value.toLowerCase()) ||
                    this.filters.language.language === i.id
                );
            });
        },
        getLanguageLevels(inputObj) {
            this.languageLevelsList = this.dictionaryByType('level_language').filter((i) => {
                return (
                    !inputObj.value ||
                    i.field_value.toLowerCase().includes(inputObj.value.toLowerCase()) ||
                    this.filters.language.languageLevel === i.id
                );
            });
        },

        async getAutocompleteAddress(inputObj) {
            const res = await this.loadAddresses(inputObj);
            this.autoCompleteAddresses = res.suggestions || [];
        },
        async getCitizenship(inputObj) {
            const res = await this.loadCountry(inputObj);
            this.autoCompleteCountry = (res.suggestions || []).map((i) => i.value);
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';
@import '~@/styles/buttons_v2';

.is-not-in-month {
    display: flex !important;
}

.user-search-filters {
    font-family: $font-montserrat;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: mrem(40);
    gap: mrem(20);

    @include on-desktop {
        width: rem(356);
        margin-bottom: 0;
        gap: rem(40);
    }

    h3 {
        @include set-font-size(18, 600, 24);
        padding: 0;
        margin: 0;
    }

    h4 {
        @include set-font-size(18, 600, 26);
        padding: 0;
        margin: 0 0 urem(16) 0;

        &.title {
            margin-bottom: urem(-24);
        }
    }

    :deep(.ui-switch) {
        margin-bottom: 0;
    }

    &__from-to {
        &-wrapper {
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: urem(32);
            row-gap: urem(10);

            &[disabled='disabled'],
            [disabled='disabled'] {
                pointer-events: none;
                cursor: initial;
                opacity: 0.5;
            }
        }

        &-title {
            grid-column: 1 /3;
            margin: 0;
            padding: 0;
            @include set-font-size(18, 400, 26);
        }

        &-date {
            width: mrem(145);
            @include on-desktop {
                width: rem(162);
            }
        }
    }

    &__projects {
        &-project,
        &-season {
            &--exclude {
                :deep(.chip) {
                    background-color: #fcf1f0;
                }
            }
        }
    }

    &__other {
        &-language {
            border-bottom: none;
            border-radius: mrem(10) mrem(10) 0 0 !important;
            margin-bottom: 0 !important;

            @include on-desktop {
                border-radius: rem(10) rem(10) 0 0 !important;
            }

            &-level {
                border-radius: 0 0 mrem(10) mrem(10) !important;
                margin-top: 0 !important;

                @include on-desktop {
                    border-radius: 0 0 rem(10) rem(10) !important;
                }
            }
        }
    }

    :deep(.yes-no-any-input) {
        margin-top: mrem(16);
        margin-bottom: mrem(16);

        @include on-desktop {
            margin-top: rem(16);
            margin-bottom: rem(16);
        }
    }
}

.radio-wrapper {
    display: flex;
    align-items: center;
}

input[type='radio'] {
    cursor: pointer;
    width: mrem(20);
    height: mrem(20);
    margin: 0 mrem(6) 0 0;
    accent-color: $color-main-blue;

    @include on-desktop {
        width: rem(20);
        height: rem(20);
        margin: 0 rem(6) 0 0;
    }
}

label {
    cursor: pointer;
    color: #2a2626;
    font-family: $font-montserrat;
    font-style: normal;
    font-weight: 400;
    font-size: mrem(18);
    line-height: mrem(26);

    @include on-desktop {
        font-size: rem(18);
        line-height: rem(26);
    }
}
</style>
